import { jsx as u } from "react/jsx-runtime";
import { useContext as E, createContext as m, useMemo as N } from "react";
import p from "axios";
const A = {};
function S() {
  var i, a;
  const { STORYBOOK_USERNAME: s, STORYBOOK_PASSWORD: t } = A, o = E(r), { NONCE: n } = o, _ = n ? {
    "X-WP-Nonce": n
  } : {
    Authorization: "Basic " + btoa(s + ":" + t)
  }, c = p.create({
    timeout: 3e4,
    headers: {
      ..._,
      "Content-Type": "application/json"
    }
  });
  return (a = (i = c.interceptors) == null ? void 0 : i.response) == null || a.use(
    // 成功處理
    (e) => e,
    // 錯誤處理
    (e) => {
      if (e.response)
        switch (e.response.status) {
          case 403:
            window.confirm(
              `
網站 Cookie 已經過期，請重新整理頁面後才能繼續使用

按 【確認】 ，重新整理頁面

或者按 【取消】 ，您可以手動複製尚未儲存的資料避免頁面刷新後遺失`
            ) && window.location.reload();
            break;
          default:
            console.error("請求失敗:", e.response.data.message);
        }
      else e.request ? console.error("沒有收到伺服器響應") : console.error("請求配置錯誤:", e.message);
      return Promise.reject(e);
    }
  ), {
    ...o,
    AXIOS_INSTANCE: c
  };
}
const r = m({
  SITE_URL: "",
  AJAX_URL: "",
  API_URL: "",
  CURRENT_USER_ID: 0,
  CURRENT_POST_ID: "",
  PERMALINK: "",
  APP_NAME: "",
  KEBAB: "",
  SNAKE: "",
  NONCE: "",
  ELEMENTOR_ENABLED: !0
}), l = ({ children: s, env: t }) => {
  const o = E(r), n = N(() => ({
    ...o,
    ...t
  }), [t, o]);
  return /* @__PURE__ */ u(r.Provider, { value: n, children: s });
};
export {
  r as EnvContext,
  l as EnvProvider,
  S as useEnv
};
